import { IAuditLogData, IAuditLogDictionary } from '@common/interfaces/auditLog'
import { combineReducers } from 'redux'
import { IAction, IActionWithParams, IPaginationParams } from '../apiMiddleware'
import * as actions from './actions'

export default combineReducers({
  loadingArray(state: string[] = [], action: IAction): string[] {
    switch (action.type) {
      case actions.LIST_AUDIT_LOG_REQUEST:
      case actions.EXPORT_AUDIT_LOG_REQUEST:
        return [...state, action.type]
      case actions.LIST_AUDIT_LOG_SUCCESS:
      case actions.LIST_AUDIT_LOG_FAILURE:
      case actions.EXPORT_AUDIT_LOG_SUCCESS:
      case actions.EXPORT_AUDIT_LOG_FAILURE:
        return state.filter(
          (item) =>
            item !== action.type.replace('SUCCESS', 'REQUEST').replace('FAILURE', 'REQUEST'),
        )
      default:
        return state
    }
  },
  data(state: IAuditLogData = null, action: IActionWithParams<IPaginationParams>): IAuditLogData {
    switch (action.type) {
      case actions.LIST_AUDIT_LOG_SUCCESS: {
        const data = action.data as IAuditLogData
        if (!action.params?.loadMore) {
          return data
        }
        return {
          ...state,
          data: [...state.data, ...data.data],
        }
      }
      default:
        return state
    }
  },
  dictionary(state: IAuditLogDictionary = null, action: IAction): IAuditLogDictionary {
    switch (action.type) {
      case actions.GET_AUDIT_LOG_DICTIONARY_SUCCESS:
        return action.data as IAuditLogDictionary
      default:
        return state
    }
  },
})
